import { initConfig } from '@cian/config/browser';
import { initLogger } from '@cian/logger/browser';
import { initTelemetry } from '@cian/telemetry/browser';
import { init as initHttpApi } from '@cian/http-api/browser';
import { init as initWeb } from '@cian/web/browser';
import { init as initGlobalBehaviors } from '@cian/global-behaviors/browser';
import { initWebview } from '@cian/webview/webview';
import { initGlobalEventsLogs } from '@cian/events-log';

export function initDependencies() {
  initConfig();
  initLogger();
  initTelemetry();
  initHttpApi();
  initWeb();
  initGlobalBehaviors();
  initWebview();
  initGlobalEventsLogs();
}
